import { LogReporter } from './log-report';


interface IGotoParams { url: string, isBlank: boolean }

export class URLManager {

  static isAbsolute(url: string) {
    return url.startsWith('http');
  }

  static goto({ url, isBlank = false }: IGotoParams) {
    if (import.meta.env.SSR) {
      return;
    }

    let address = this.isAbsolute(url) ? new URL(url) : new URL(url, location.href);

    // 页面跳转前添加fromSpmId
    if (!address.searchParams.has('fromSpmId')) {
      const spmId = LogReporter.getSpmId() || '';
      address.searchParams.set('fromSpmId', spmId);
    }

    isBlank ? window.open(address.href) : window.location.href = address.href;
  }

}